import React from "react";
import { Container, Grid, Typography } from "@material-ui/core";
import {
  useAddReportDefinitionsToTestSequence,
  useCreateReportSequence,
} from "../../projectManagementMutations";

import { toast } from "react-toastify";
import { useHistory } from "react-router";

import LSDBColorPicker from "../../../common/LSDBColorPicker";
import {
  addProcedureDefinitionToList,
  removeProcedureDefinitionFromList,
} from "./ReportDefinitions/helpers";
import RSDForm from "./RSDForm";
import ReportDefinitionsPicker from "./ReportDefinitions/ReportDefinitionsPicker";
import { ReportExecutionOrder } from "../../types/ReportExecutionOrder";

const NewRSD = () => {
  const history = useHistory();

  const [selectedReportDefinitions, setSelectedReportDefinitions] =
    React.useState<ReportExecutionOrder[]>([]);
  const [RsdHexColor, setRsdHexColor] = React.useState("#000000");

  const { mutateAsync: createReportSequence } = useCreateReportSequence();
  const { mutateAsync: addProcedureDefinitionsToTestSequence } =
  useAddReportDefinitionsToTestSequence();
   
  const addProcedureDefinitionToSelectedList = (
    procedureDefinition: ReportExecutionOrder
  ) => {
    setSelectedReportDefinitions((prevState) =>
      addProcedureDefinitionToList(prevState, procedureDefinition)
    );
  };

  const removeProcedureDefinitionFromSelectedList = (
    procedureDefinition: ReportExecutionOrder
  ) => {
    setSelectedReportDefinitions((prevState) =>
      removeProcedureDefinitionFromList(prevState, procedureDefinition)
    );
  };

  const editProcedureDefinitionInSelectedList = (
    procedureDefinitionToEdit: ReportExecutionOrder,
    newProcedureDefinition: ReportExecutionOrder
  ) => {
    setSelectedReportDefinitions((prevState) =>
      addProcedureDefinitionToList(
        removeProcedureDefinitionFromList(prevState, procedureDefinitionToEdit),
        newProcedureDefinition
      )
    );
  };

  const handleColorChange = (color: string) => {
    setRsdHexColor(color);
  };

  return (
    <React.Fragment>
      <Container>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography variant="h3">New Report Sequence Definition</Typography>
          </Grid>

          <Grid item xs={12}>
            <RSDForm
              submitForm={async (values) => {
                console.log({ values, hex_color: RsdHexColor });
                try {
                  await createReportSequence(
                    {
                      name: values.name,
                      short_name: values.shortName,
                      description: values.description,
                      disposition: values.disposition,
                      version: values.version,
                      // group: values.group,
                      // unit_type_family: values.unitTypeFamily,
                      hex_color: RsdHexColor,
                    },
                    {
                      onSuccess: async ({ id }) => {
                        toast.success(`Created Report sequence ${id}`);

                        if (selectedReportDefinitions.length !== 0) {
                          try {
                            await addProcedureDefinitionsToTestSequence(
                              {
                                reportSequenceId: id,
                                reportDefinitions:
                                  selectedReportDefinitions,
                              },
                              {
                                onSuccess: () => {
                                  toast.success(
                                    "Added selected report definitions to report sequence"
                                  );
                                },
                              }
                            );
                          } catch (err) {
                            toast.error(
                              "Failed to add report definition to report sequence"
                            );
                          }
                        }

                        history.push(`${id}`);
                      },
                    }
                  );
                } catch (e) {
                  toast.error("Failed to create report Sequence Definition");
                }
              }}
              selectedProcedureDefinitionsIsEmpty={
                selectedReportDefinitions.length === 0
              }
            >
              <LSDBColorPicker
                chipLabel="Report Sequence Definition Color"
                onChange={handleColorChange}
              />
              <ReportDefinitionsPicker
                rsdProcedureDefinitions={selectedReportDefinitions}
                onAddItem={(newProcedureDefinition) => {
                  console.log("Adding new item to a new TSD");
                  console.log({ item: newProcedureDefinition });
                  addProcedureDefinitionToSelectedList(newProcedureDefinition);
                }}
                onEditItem={(
                  oldProcedureDefinition,
                  newProcedureDefinition
                ) => {
                  console.log("Editing existing item on a new TSD");
                  console.log({
                    oldPD: oldProcedureDefinition,
                    newPD: newProcedureDefinition,
                  });
                  editProcedureDefinitionInSelectedList(
                    oldProcedureDefinition,
                    newProcedureDefinition
                  );
                }}
                onDeleteItem={(procedureDefinitionToDelete) => {
                  console.log("Deleting item on a new TSD");
                  console.log({ item: procedureDefinitionToDelete });
                  removeProcedureDefinitionFromSelectedList(
                    procedureDefinitionToDelete
                  );
                }}
              />
            </RSDForm>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default NewRSD;
